<template>
    <div class="StatisticsMarketingDelivrability">
        <v-row class="pa-4 pb-0">
            <template v-for="(filter, index) in filters">
                <vDaterangePicker v-if="filter.type == 'dateperiod'" mode="past" v-model="filter.value" @change="reloadData" class="mr-6" :label="index" :key="'daterange_' + index" />
                <v-autocomplete v-else-if="filter.type == 'select'" :no-data-text="$t('noData')" multiple clearable v-model="filter.value" class="mr-6 mt-0 pt-0" @change="reloadData" :items="filter.items" style="max-width: 200px;" :label="$t(index)" :key="'select_' + index" />
                <v-switch v-else-if="filter.type == 'toggle' && filters.entity.value.length" v-model="filter.value" class="mr-6 mt-0 pt-0" @change="reloadData" :label="$t(index)" :key="'switch_' + index" />
            </template>
        </v-row>

        <v-row class="mt-0">
            <v-col cols="4">
                <div class="counters">
                    <v-card color="#EEF3F1">
                        <v-card-text>
                            <v-row>
                                <v-col class="border-right">{{ instantData.STATS ? instantData.STATS.nb_campaigns : " X " }} {{ $t("campaigns") }}</v-col>
                                <v-col>{{ instantData.MSG_SENT !== undefined ? instantData.MSG_SENT : " X " }} {{ $t("recipients") }}</v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </div>
                <div class="mt-6">
                    <statisticsDonutComponent :stats="instantData" dataKey="MSG_DOMAINS" />
                </div>
                <div class="mt-6">
                    <statisticsDonutComponent :stats="instantData" dataKey="MSG_SOFT_BOUNCE_CATEGORIES" />
                </div>
            </v-col>

            <v-col cols="8">
                <div>
                    <statisticsEventsDetail :stats="instantData" />
                </div>
                <div class="mt-6">
                    <statisticsEvolutionComponent v-if="loadData" :stats="evolutionData" />
                </div>
                <div class="mt-6">
                    <statisticsEventsListComponent :filters="filters" :instantData="instantData" />
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import GenericDataService from '@/services/GenericDataService';
import vDaterangePicker from '@/components/forms/inputs/v-daterange-picker.vue';
import statisticsDonutComponent from '../components/statisticsDonutComponent';
import statisticsEventsDetail from '../components/statisticsEventsDetail';
import statisticsEvolutionComponent from '../components/statisticsEvolutionComponent';
import statisticsEventsListComponent from '../components/statisticsEventsListComponent';

export default {
    name: "StatisticsMarketingDelivrability",
    props: ['loadData'],
    components: {
        vDaterangePicker, statisticsDonutComponent, statisticsEventsDetail, statisticsEvolutionComponent, statisticsEventsListComponent, 
    },
    data() {
        return {
            filters: {},
            instantData: {},
            evolutionData: null,
        }
    },
    destroyed() {
        this.$store.dispatch('SET_LOADER_DASHBOARD', false);
    },
    methods: {
        initFilters() {
            GenericDataService.getData('/stats/getStatisticsFilters').then((response)=> {
                this.filters = response.data.data;

                this.$store.dispatch('SET_LOADER_DASHBOARD', false);

                this.initInstantData();
                this.initEvolutionData();
            });
        },
        reloadData() {
            if(!this.filters.period.value.start || !this.filters.period.value.end) {
                this.filters.period.value = {
                    start: new Date(new Date().getFullYear(), new Date().getMonth(), 1, 12, 0, 0).toISOString().slice(0, 10), // Si changement ici il faut répercuter dans le back stats.php dans "getStatisticsFilters"
                    end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0, 12, 0, 0).toISOString().slice(0, 10) // Si changement ici il faut répercuter dans le back stats.php dans "getStatisticsFilters"
                };
            }

            this.initInstantData();
            this.initEvolutionData();
        },
        initInstantData() {
            this.instantData = {};

            GenericDataService.postData('/stats/getStatistics', { filters: this.filters }).then((response)=> {
                this.instantData = response.data.data;
            });
        },
        initEvolutionData() {
            this.evolutionData = null;

            GenericDataService.postData('/stats/getStatisticsEventsEvolution', { filters: this.filters }).then((response)=> {
                this.evolutionData = response.data.data;
            });
        },
    },
    created() {
        this.$store.dispatch('SET_LOADER_DASHBOARD', true).then((e) => {
            this.initFilters();
        });
    },
}
</script>

<style lang="scss">
    .StatisticsMarketingDelivrability {
        .counters {
            .col {
                color: #647F73;
                font-weight: 800;
                font-size: 1.4em;

                display: flex;
                justify-content: center;

                &.border-right {
                    border-right: 1px solid #647f7337;
                }
            }
        }
    }
</style>